import { Component, OnDestroy } from '@angular/core';
import {
  TaggingResolutionChoice,
  TaggingResolutionChoices,
  TaggingValidation,
  TaggingValidationType,
  TagItemVendorService,
} from '../tag-item-vendor.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import {
  TaggingValidationDialogComponent,
  TaggingValidationDialogData,
  TaggingValidationDialogResult,
} from '../tagging-validation-dialog/tagging-validation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-tagging-validation',
  templateUrl: './tagging-validation.component.html',
  styleUrls: ['./tagging-validation.component.scss'],
})
export class TaggingValidationComponent implements OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  private dialogSubscription?: Subscription;

  constructor(
    private tagItemVendorService: TagItemVendorService,
    private taggingValidationDialog: MatDialog
  ) {
    this.tagItemVendorService.taggingValidation$
      .pipe(takeUntil(this.destroy$))
      .subscribe((validationData: TaggingValidation) => {
        this.openDialog(validationData);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();

    if (this.dialogSubscription) {
      this.dialogSubscription.unsubscribe();
    }
  }

  private openDialog(validationData: TaggingValidation) {
    if (this.dialogSubscription) {
      this.dialogSubscription.unsubscribe();
    }

    const dialogData: TaggingValidationDialogData = {
      ...validationData,
    };

    const dialogRef = this.taggingValidationDialog.open(
      TaggingValidationDialogComponent,
      {
        width: '600px',
        data: dialogData,
      }
    );

    this.dialogSubscription = dialogRef
      .afterClosed()
      .subscribe((result: TaggingValidationDialogResult) => {
        if (result?.data) {
          const { data, form } = result;
          const { type, incomingTaggedGroup, existingTaggedGroupRef } = data;

          // Resolvable validation type
          const resolutionChoices: TaggingResolutionChoices = {};

          switch (type) {
            case TaggingValidationType.EXISTING_VENDOR_TAGGED:
              resolutionChoices[TaggingValidationType.EXISTING_VENDOR_TAGGED] =
                TaggingResolutionChoice.REMOVE_AFFECTED;
              break;
            case TaggingValidationType.DUPLICATED_VENDOR_SET:
              resolutionChoices[TaggingValidationType.DUPLICATED_VENDOR_SET] =
                form.choice as TaggingResolutionChoices[TaggingValidationType.DUPLICATED_VENDOR_SET];
              break;
          }

          // Re-trigger service again after making resolution choice
          if (Object.keys(resolutionChoices).length > 0) {
            if (existingTaggedGroupRef) {
              // Is update
              this.tagItemVendorService.updateTaggedGroup(existingTaggedGroupRef, incomingTaggedGroup!, resolutionChoices)
            } else {
              // Is add
              this.tagItemVendorService.addTaggedGroup(incomingTaggedGroup!, resolutionChoices)
            }
          }
        }
      });
  }
}
